<template>
	<div style="">
		
		<div v-show="canRefresh || showCategories">
				<div class="uk-grid uk-margin-bottom" style="margin-top: -5px">
						<div :class="[canRefresh && showCategories ? 'uk-width-1-2' : 'uk-width-1-1', 'uk-text-center']" v-show="canRefresh">
								<button @click="reloadEntries" class="uk-icon-button" uk-icon="refresh"></button><br />
								 Vernieuwen
						</div> 
						<div :class="[canRefresh && showCategories ? 'uk-width-1-2' : 'uk-width-1-1', 'uk-text-center']" v-show="showCategories">
								<button uk-toggle="target: #offcanvas-categories-videos" class="uk-icon-button" uk-icon="chevron-down"></button><br />
								Thema's
						</div>
				</div>
		</div>

		<div v-for="(entry, index) in entries" :key="entry.id">

			<!-- ads -->
			<div v-if="index == 5 || (index > 5 && index % 10 === 0) && !isMobile" class="r89-desktop-leaderboard-atf-video uk-margin-top uk-margin-bottom"></div>
			<div v-if="index == 5 || (index > 5 && index % 10 === 0) && isMobile" class="r89-mobile-rectangle-infinite-video uk-margin-top uk-margin-bottom"></div>
			
			<!-- trending videos data -->
			<div style="max-height: 400px" v-if="trendingVideos.enabled && index == trendingVideos.position" v-html="trendingVideosHtml"></div>
			
			<!-- video container -->
			<div class="video-container" :class="{ 'uk-padding' : padding }">
					<div>			
						<h3 class="title">
							<a :href="entry.url" target='_blank'>{{ entry.title }}</a>
						</h3>
					</div>
					<div class="media uk-margin-">

						<!-- video -->
						<div v-if="entry.media.type == 'upload'" class="uk-border-rounded">
							<video-player 
								:id="entry.media.id"
								:analytics="true"	
								title="entry.title"
								:ads="{ 
									'website': false, 
									'app': false
								}"								
								:ads-vdur="10"
								:viewport-observer="true"
								:plays-inline="true"
								:auto-size="true" 
								:consent-check="false"
								force-max-height="60vh"
								:auto-play="autoPlay"
								:options="{
									autoplay: false,
									loop: true,
									fluid: true,
									fill: true,
									width: entry.media.width,
									height: entry.media.height,
									poster: entry.media.poster,
									sources: [
										{ src: entry.media.url, type: 'video/mp4' },
										{ src: entry.media.original, type: 'video/mp4' }
									]
								}">
							</video-player>
						</div>
						
						<!-- html code -->
						<div v-if="entry.media.type == 'html'" class="responsive-video uk-border-rounded">
							<div v-html="entry.media.code"></div>
						</div>
						
					</div>
										
					<!-- footer -->
					<div class="uk-grid-small uk-flex-middle meta" uk-grid>
							
						<div class="uk-width-1-3">
							<span v-for="(tag, index) in entry.tags.slice(0, 3)" :key="tag.slug" class="uk-text-light">
								<a class="tag" :href="'/videos/' + tag.slug">{{ tag.title }}{{ index !== 2 && index !== entry.tags.length - 1 ? ', ' : '' }}</a>
							</span>
						</div>
						<div class="uk-width-expand">
						</div>						
						<div class="uk-width-auto uk-text-right">	
							<div class="uk-flex uk-flex-middle uk-flex-right">
															
								<article-share 
									:url="entry.url" 
									:title="entry.title"
									:site-name="siteName"
									:mailto="siteEmail"
									:nav-bar-item="true"
									:show-label="false"
								></article-share> 
					
								<up-vote 
									ref="voting" 
									:element-id="entry.id"
									:up-votes="entry.votes.totalUpVotes"
									:down-votes="entry.votes.totalDownVotes"
									:show-up-vote="true"
									:show-down-vote="true"
									:show-tally-vote="false"
									:nav-bar-item="true"
								></up-vote>	
							
								<comments-modal v-if="entry.commenting" 
									:total-comments="entry.totalComments" 
									:url="'/async/comments?id=' + entry.id"
									:js-variables="entry.commentsVariables"
									:nav-bar-item="true"
									:show-label="false"
								></comments-modal>

							</div>
						</div>
					</div>
					<!-- // footer -->
					
				</div>
		
		</div>
		<div ref="intersectionObserverTarget" class="intersection-observer-target"></div>
		<div class="uk-relative uk-padding-large" v-if="loading">
			<div class="uk-position-center"><LoadingIndicator v-if="loading" /></div>
		</div>
		<div v-if="error" class="error-message">{{ error }}</div>
		<div v-if="noMoreItems" class="uk-alert uk-padding uk-margin-remove no-more-items-message">
			Geen video's (meer) gevonden, sorry!
		</div>
	</div>
</template>

<script>
import axios from 'axios';

import LoadingIndicator from './LoadingIndicator.vue';
import CommentsModal from './CommentsModal.vue'
import UpVote from './UpVote.vue'
import ArticleShare from './ArticleShare.vue'
import VideoPlayer from './VideoPlayer.vue'

export default {
	components: {
		LoadingIndicator,
		CommentsModal,
		UpVote,
		ArticleShare,
		VideoPlayer
	},
	props: {
		feedUrl: {
			type: String,
			required: true,
		},
		categorySlug: {
			type: String,
			required: false,
			default: ''
		},
		canRefresh: {
			type: Boolean,
			required: false,
			default: false
		},
		autoPlay: {
			type: Boolean,
			default: false
		},
		padding: {
			type: Boolean,
			default: false
		},
		showCategories: {
			type: Boolean,
			default: false
		},
		trendingVideos: {
			type: Object,
			default() {
				return {
					'enabled': false,
					'position': 1,
					'url': '/async/videos_swiper'
				};
			}		
		}
	},
	data() { 
		return {
			loading: false,
			error: null,
			entries: [],
			page: 1,
			intersectionObserver: null,
			noMoreItems: false, // Track if there are no more items
			trendingVideosHtml: null
		};
	},
	mounted() {
		this.setupIntersectionObserver();
		this.fetchentries();
		
		if(this.trendingVideos) {
			this.fetchTrendingVideos();
		}		
	},
	computed: {
		isMobile() {
			return this.$root.device.mobile;
		},
		isRedactie() {
			return this.$root.user.isRedactie;
		},
		siteName() {
			return this.$root.site.name;
		},
		siteEmail() {
			return this.$root.site.email;
		}
	},
	methods: {
		getNewWdith(width,height) {
			let origWidth = width; // Replace with your video's original width
			let origHeight = height; // Replace with your video's original height
			let maxHeight = 300; // The new maximum height for the video
			let newWidth = (origWidth / origHeight) * maxHeight;			
			return newWidth;
		},
		getAspectRatio(width, height) {
					
			if(height && width) {
				return `${width}:${height}`;
			} else {
				return '16:9';
			}
					
			if (height && width) {
				return `${width}:${height}`;
			} else {
				return '16:9';
			}
		},
		reloadEntries() {
			this.page = 1;
			this.entries = [];
			this.fetchentries();
		},
		fetchentries() {
			
			if (this.loading || this.noMoreItems) return;

			var url;
			
			// Add pagination
			url = `${this.feedUrl}/p${this.page}`;
			
			this.$logger('app/components/video-timeline/fetch-entries');
			
			// Add category slug 
			if(this.categorySlug) {
				url = this.$helper.updateQueryStringParameter(url, 'categorySlug', this.categorySlug);
			} 

			this.$logger('app/components/video-timeline/fetch-entries/url: ' + url);
					
			this.loading = true;

			axios
				.get(url)
				.then((response) => {
					const newItems = response.data.items;
					if (newItems.length < 1) {
						this.noMoreItems = true;
						this.intersectionObserver.disconnect();
					} else {
						this.entries = [...this.entries, ...newItems];
						this.page++;
					}
					this.loading = false;
				})
				.catch((error) => {
					this.error = 'An error occurred while fetching entries.';
					if(typeof error != 'undefined') {
						console.error(error);
					}
					this.loading = false;
				});
		},
		setupIntersectionObserver() {
			this.intersectionObserver = new IntersectionObserver(
				(entries) => {
					const target = entries[0];
					if (target.isIntersecting && !this.loading && !this.error && !this.noMoreItems) {
						this.fetchentries();
					}
				},
				{
					root: null,
					rootMargin: '0px 0px 1000px 0px',
					threshold: 0.1, 
				}
			);

			this.intersectionObserver.observe(this.$refs.intersectionObserverTarget);
		},
		fetchTrendingVideos() {
			
			var component = this;
			
			component.$logger('app/components/video-timeline/fetch-trending-videos');
			
			var url = component.trendingVideos.url;
			
			if(!url) return;

			axios
				.get(url)
				.then((response) => {
					console.log(response)
					//component.trendingVideosHtml = 'test'
					component.trendingVideosHtml = response.data;
				})
				.catch((error) => {
					console.error(error)
				});
						
		}		
	},

};
</script>

<style scoped>
.intersection-observer-target {
	height: 1px;
}
.error-message {
	color: red;
}
.no-more-items-message {
	text-align: center;
	margin-top: 20px;
	font-weight: bold;
}

</style>
